import { render, staticRenderFns } from "./profileKycForm.vue?vue&type=template&id=07971be6"
import script from "./profileKycForm.vue?vue&type=script&lang=js"
export * from "./profileKycForm.vue?vue&type=script&lang=js"
import style0 from "./profileKycForm.vue?vue&type=style&index=0&id=07971be6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports